import { getAuthToken } from "@/features/shared/features/authentication";
import { DimensionValueSet } from "@/lib/dimensions";
import { appendVerticalQueryParam } from "@/lib/dimensions/helpers";

export default class ModelLayerLegendImageLoader {
  private baseUrl;

  constructor(modelId: string, layerId: string) {
    this.baseUrl = `${
      import.meta.env.VITE_API_BASE_PATH
    }/parameters/models/${modelId}/map_layers/${layerId}/legend`;
  }

  async loadLegendImage(dimensionValues: DimensionValueSet): Promise<Blob | undefined> {
    const response = await fetch(this.legendImageUrl(dimensionValues), {
      headers: {
        Authorization: `Bearer ${getAuthToken()?.access_token}`,
      },
    });

    if (!response.ok) throw new Error(response.statusText, { cause: response });

    return response.blob();
  }

  private legendImageUrl(dimensionValues: DimensionValueSet): string {
    const queryString = this.mapDimensionsToQueryString(dimensionValues);
    return `${this.baseUrl}?${queryString.toString()}`;
  }

  private mapDimensionsToQueryString(dimensionValues: DimensionValueSet) {
    const params = new URLSearchParams();
    const referenceTime = dimensionValues["reference_time"]?.queryStringValue;
    const time = dimensionValues["time"]?.queryStringValue;

    if (referenceTime) params.set("reference_time", referenceTime);
    if (time) params.set("time", time);
    appendVerticalQueryParam(params, dimensionValues);

    return params;
  }
}
